export const EDUCATION_OPTIONS = [
  {
    value: "osnovno_obrazovanje",
    description: "Osnovno obrazovanje (Primary Education)",
  },
  {
    value: "srednje_obrazovanje",
    description: "Srednje obrazovanje (Secondary Education)",
  },
  {
    value: "visa_skola",
    description: "Viša škola (Associate Degree / Polytechnic)",
  },
  {
    value: "vss_sveucilisni_prvostupnik",
    description: "VSS - Sveučilišni prvostupnik (Bachelor's Degree)",
  },
  {
    value: "vss_magistar",
    description: "VSS - Magistar (Master's Degree)",
  },
  {
    value: "doktor_znanosti",
    description: "Doktor znanosti (Doctorate / PhD)",
  },
];

export const hrJmbgRegEx = /^\d{13}$/;
export const hrOibRegEx = /^\d{11}$/;
export const hrOsobniBrojRegEx = /^[0-9A-Z]{1,10}$/;
